import React from 'react'
import ReportStandardUserListMobileTab from './ReportStandardUserListMobileTab'
import { buildReportSummaryUserMobileCardSections } from './reportSummaryUserMobileCardModel'
export default function ReportSummaryMobileTab(props) {
  return (
    <ReportStandardUserListMobileTab
      {...props}
      buildCardSections={buildReportSummaryUserMobileCardSections}
      showSummaryTabKpis
    />
  )
}
